webpackJsonp([228578108878866],{

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/travel_phenomena_cover.e0172e6f.jpg";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImageGallery = __webpack_require__(27);
	
	var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
	
	__webpack_require__(25);
	
	var _travel_phenomena_cover = __webpack_require__(519);
	
	var _travel_phenomena_cover2 = _interopRequireDefault(_travel_phenomena_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SunSmartPage = function SunSmartPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 project-info' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Travel Phenomena'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '\u201EWhen Yeow Mei Jyn, 33, travels, she has a carry-on luggage that weighs close to 10kg containing nothing but gadgets! She brings along two phones [\u2026], two cameras [\u2026], lenses, an external hard drive and, on shorter trips, a laptop. (No, this flashpacker is not a photographer)\u201C (Revathi Murugappan 2010)'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We are living in a world that has to deal with mediatisation, globalisation, pluralisation, individualisation and acceleration. These social and cultural changes cause people to develop strategies and postmodern phenomena occur.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The research examines numerous travel blogs with a cultural studies perspective to analyse the phenomena of Backpackers and Flashpackers. Based on the processes of globalization, all parts of life accelerated and mediatized. It changes the understanding of how to perceive time and space. With the background of a globalized world, modalities of travelling and coping strategies emerge. Phenomena of the postmodern world, as Backpackers and Flashpackers, developed their own point of view of this world. The focus of the analysis describes the experience of time and space while travelling through the globalized world.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A further analysis of the material will be provided upon request.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'slider' },
	                    _react2.default.createElement(_reactImageGallery2.default, {
	                        showThumbnails: false,
	                        showFullscreenButton: false,
	                        autoPlay: true,
	                        items: [{ original: _travel_phenomena_cover2.default }] })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'project-blurb' },
	                    'Research about the time and space perception of Backpacker and Flashpacker.'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Travel blogs'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Backpacker'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Flashpacker'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Cultural Studies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Phenomenology'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Sociology'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Communication and Media Studies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Tourism'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Cooperation Partner:'
	                        ),
	                        ' O.-v.-G. University Magdeburg'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Source:'
	                        ),
	                        ' a number of selected travel blogs'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Date:'
	                        ),
	                        ' April - October 2010'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SunSmartPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-travel-phenomena-js-c42c386df540c3368b0d.js